import { HttpClient }  from '@angular/common/http';
import { Injectable }  from '@angular/core';
import { of, Subject } from 'rxjs';
import { map }         from 'rxjs/operators';

import { AppConfigurationService } from 'src/app/core/services/configuration/app-configuration.service';

import { Campus } from 'src/app/core/models/api/campus.model';

@Injectable({
    providedIn: 'root'
})
export class CampusService {
    
    private campusCode: string;
    private apiURL    : string;

    campusActive: Campus;
    campusActiveData  = new Subject<Campus>();
    campusActiveData$ = this.campusActiveData.asObservable();

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) { 

        this.apiURL     = this.appConfigurationService.baseApi + '/campus';
        this.campusCode = this.appConfigurationService.campusCode;

    }
        
    getCampusByCode(): any {

        const url = this.apiURL + '/' + this.campusCode;
        return this.http.get<Campus>(url).pipe(
            map((data) => {
                this.campusActive = data;
                this.campusActiveData.next();
            })
        );

    }

}
